import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import { useMediaQuery } from '@mui/material';

export default function BasicModal({title, subText, buttonFunction, buttonText, buttonStlye}) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const modalStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '65vw',
      bgcolor: 'background.paper',
      borderRadius: 4,
      boxShadow: 24,
      p: 4,
    }
  const mobileModalStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '65vw',
      bgcolor: 'background.paper',
      borderRadius: 4,
      boxShadow: 24,
      p: 4,
    }

  return (
    <div>
      <Button variant='text' color="inherit" sx={buttonStlye} onClick={handleOpen}>{buttonText}</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }}>
            {subText}
          </Typography>
          <Stack direction={'row'} sx={{p:0, justifyContent:'space-between'}}>
            <Button variant='outlined' sx={{}} onClick={handleClose}>Cancel</Button>
            {buttonFunction!==0 ? (<Button variant='contained' onClick={() => {
              handleClose()
              buttonFunction()
            }}>Confirm</Button>):(<></>)}
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}